const BridgeEvents = {
    ResizeFrame: (height) => {
        console.log("Adjusting frame height to", height);
        window.parent.postMessage(JSON.stringify({iframeHeight: height}), "*");
    },
    FormFinished: () => {
        console.log("Firing bridge event: FormFinished");
        window.parent.postMessage(JSON.stringify({formAction: "submit"}), "*");
    },
    FormError: (submitCount) => {
        if(window.lastFormErrorSubmitCount === submitCount){
            return;
        }
        console.log("Firing bridge event: FormError");
        window.parent.postMessage(JSON.stringify({formAction: "error"}), "*");
        window.lastFormErrorSubmitCount = submitCount;
    },
    FormStarted: () => {
        if(window.formStartedEventSent){
            return
        }
        console.log("Firing bridge event: FormStarted");
        window.parent.postMessage(JSON.stringify({formAction: "start"}), "*");
        window.formStartedEventSent = true;
    },
}

export default BridgeEvents;
